import { GENERIC_ERROR_MESSAGE } from "@/constants";

export default {
  namespaced: true,
  state: {
    snackbar: false,
    message: ""
  },
  getters: {
    snackbar: state => state.snackbar,
    message: state => state.message
  },
  mutations: {
    SET_SNACKBAR(state, data) {
      state.snackbar = data;
    },
    SET_MESSAGE(state, data) {
      state.message = data;
    }
  },
  actions: {
    openBeExceptionSnackbar({ commit }, err) {
      console.log(err);
      const msg = err.response.data.status === 400 ? err.response.data.title : err.response.data.detail;
      commit("SET_SNACKBAR", true);
      commit("SET_MESSAGE", msg);
    },
    openErrorSnackbar({ commit }, err) {
      console.log(err);
      commit("SET_SNACKBAR", true);
      commit("SET_MESSAGE", GENERIC_ERROR_MESSAGE);
    },
    openSnackbar({ commit }, message) {
      commit("SET_SNACKBAR", true);
      commit("SET_MESSAGE", message);
    },
    closeSnackbar({ commit }) {
      commit("SET_SNACKBAR", false);
      commit("SET_MESSAGE", "");
    }
  }
};
